<div id="gradient" class="container" [ngClass]="{'sticky': isSticky}">
  <div class="hamburger-menu-container">
    <ng-content select="[hamburger-menu]"></ng-content>
  </div>

  <div class="wrapper">
    <ng-content></ng-content>
  </div>

  <div class="toggle-sticky-container" *ngIf="!isScc">
    <span *ngIf="!isSticky" (click)="switchSticky()" class="material-icons-outlined sticky-toggle"> push_pin </span>
    <span *ngIf="isSticky" (click)="switchSticky()" class="material-icons sticky-toggle"> push_pin </span>
  </div>
</div>
